import { css } from '@/styled-system/css';

export const stack = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  fontSize: 'body',
  lineHeight: 'body',
  '& p': { margin: 0 },
});
export const topics = css({
  display: 'grid',
  gap: 'tighter',
  '@container apartment-reviews (min-width: 48em)': { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
});
export const topic = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tight',
  padding: 'tight',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.muted',
  borderRadius: 'md',
  minWidth: 0,
});
export const topicIcon = css({
  display: 'grid',
  placeItems: 'center',
  flexShrink: 0,
  width: '800',
  height: '800',
  borderRadius: 'md',
  backgroundColor: 'blue.100',
  color: 'blue.500',
  '&[data-topic=neighborhood]': { backgroundColor: 'teal.100', color: 'teal.500' },
  '&[data-topic=safety]': { backgroundColor: 'aqua.100', color: 'aqua.600' },
  '&[data-topic=transit]': { backgroundColor: 'purple.100', color: 'purple.500' },
  '&[data-topic=lifestyle]': { backgroundColor: 'orange.100', color: 'orange.600' },
});
export const topicCopy = css({ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 'micro.default' });
export const topicTitle = css({ fontSize: 'body', fontWeight: 'bold', margin: 0 });
export const topicDescription = css({ color: 'text.subtle', minHeight: '1200', lineClamp: 2 });
export const disclaimer = css({ fontSize: 'body-sm', lineHeight: 'body-sm', color: 'text.subtle' });
